import { withLazyLoading } from '@atlaskit/editor-common/lazy-node-view';
import { fg } from '@atlaskit/platform-feature-flags';
import { editorExperiment } from '@atlaskit/tmp-editor-statsig/experiments';
import { ReactMediaNode } from './mediaNodeView';
export var lazyMediaView = function lazyMediaView(portalProviderAPI, eventDispatcher, providerFactory) {
  var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  var api = arguments.length > 4 ? arguments[4] : undefined;
  if (fg('platform_editor_ssr_media') || editorExperiment('platform_editor_exp_lazy_node_views', false)) {
    return ReactMediaNode(portalProviderAPI, eventDispatcher, providerFactory, options, api);
  }
  return withLazyLoading({
    nodeName: 'media',
    getNodeViewOptions: function getNodeViewOptions() {},
    loader: function loader() {
      var result = import( /* webpackChunkName: "@atlaskit-internal_editor-plugin-media-lazy-node-view" */
      './mediaNodeView').then(function (_ref) {
        var ReactMediaNode = _ref.ReactMediaNode;
        return function (node, view, getPos) {
          return ReactMediaNode(portalProviderAPI, eventDispatcher, providerFactory, options, api)(node, view, getPos);
        };
      });
      return result;
    }
  });
};